const models = document.querySelector('.models');

if (models) {
  if (models.children.length >= 10) {
    models.classList.add('models--medium');
  } else if (models.children.length >= 30) {
    models.classList.add('models--large');
  }
}
